import * as CONSTANTS from '../constants/constants';

var initialState = {
    activeLecture:{}
}

const playlistReducer = (state=initialState,action)=>{
    switch(action.type){
        case CONSTANTS.UPDATE_PLAYLIST:
            return Object.assign({},state, {
                activeLecture:action.payload
            })
        default: return state
    }
}

export default playlistReducer